import { useState, useContext } from "react";

import Modal from "../../../../../../components/global/Modal";
import ResponseModal from "../../../../../../components/global/ResponseModal";
import { Typography } from "@mui/material";
import { useRevalidator } from "react-router-dom";
import useService from "../../../../../../hooks/useService";

export default function DeleteExpense({
  activeExpense,
  deductionOpts,
  open,
  setActiveExpense,
  setOpen,
}) {
  const additionalExpenseRepository = useService('repositories/additional-expense-repository');
  const { revalidate } = useRevalidator();
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setActiveExpense(null);
  };

  const handleDelete = async () => {
    setLoading(true);
    
    try {
      await additionalExpenseRepository.delete(activeExpense.id);
      setLoading(false);
      setOpenSuccess(true);
      revalidate();
      handleClose();
    } catch (error) {
      setLoading(false);
      if (error.response) {
        setOpenError(!openError);
        let res = error.response.data;
        let errArr = [];
        for (const item in res) {
          errArr.push(item + `: ${res[item]}`);
        }
        setErrorArray(errArr);
      }
    }
  };

  return (
    <>
      <Modal
        open={open}
        fullWidth
        maxWidth="sm"
        title="Delete Expense"
        onClose={handleClose}
        actions={[
          {
            isLoading: loading,
            onClick: handleDelete,
            label: "Delete Expense",
            variant: "outlined",
            className:
              "border-red-500 text-red-500 hover:bg-red-500 hover:text-white",
          },
        ]}
      >
        <div className="flex flex-wrap items-center w-full p-6">
          <div className="flex w-full">
            <Typography variant="h6" className="text-lg font-bold w-fit">
              Label:
            </Typography>
            <Typography variant="h6" className="ml-2 text-lg w-fit">
              {activeExpense?.label ?? ""}
            </Typography>
          </div>
          <div className="flex w-full">
            <Typography variant="h6" className="text-lg font-bold w-fit">
              Amount:
            </Typography>
            <Typography variant="h6" className="ml-2 text-lg w-fit">
              {activeExpense?.amount ?? ""}
            </Typography>
          </div>
          <div className="flex w-full">
            <Typography variant="h6" className="text-lg font-bold w-fit">
              Deducted From:
            </Typography>
            <Typography variant="h6" className="ml-2 text-lg w-fit">
              {deductionOpts.find(
                (opt) => opt.value === activeExpense?.deductionType
              )?.display_name ?? ""}
            </Typography>
          </div>
        </div>
      </Modal>
      <ResponseModal
        title="Expense Removed"
        description="Expense has been successfully deleted"
        openBool={openSuccess}
        setOpenBool={setOpenSuccess}
        handleCloseFunc={() => setOpenSuccess(false)}
      />
      <ResponseModal
        title="Error Removing Expense"
        isError={true}
        openBool={openError}
        setOpenBool={setOpenError}
        errorMessage={errorArray}
      />
    </>
  );
}
